// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2xN5N","header":"ClearentDisclaimer_header__3v-VZ","inner":"ClearentDisclaimer_inner__3ynFN"};